"use client";

import dynamic from "next/dynamic";

export const HomeFeaturesBrowser = dynamic(
    () => import("./Features")
        // this part is needed if your use a named export
        // you can replace by ".default" when using a default export
        .then((mod) => mod.HomeFeatures),
    {
        // This prevents server-side rendering of BrowserComponent
        ssr: false,
    }
);